import { FC, memo } from 'react'
import * as S from './styles'
import { GalleryItemProps } from './types'

type MasonryCardProps = {
  item: GalleryItemProps
  isLastColumn: boolean
  priority?: boolean
}

const MasonryCardComponent: FC<MasonryCardProps> = ({ item, isLastColumn }) => (
  <S.ImageWrapper width={item.image.width} height={item.image.height}>
    <S.Skeleton />
    {/* eslint-disable-next-line @next/next/no-img-element */}
    <img
      src={item.image.sizes?.medium || item.image.url}
      alt={item.image?.alt || item.title}
      width={item.image.width}
      {...({ fetchPriority: 'high' } as any)}
      height={item.image.height}
      style={{
        width: '100%',
        height: 'auto',
        display: 'block'
      }}
    />

    <S.ImageInfos className='image-infos' isLastColumn={isLastColumn}>
      <S.ImageInfosRectangle isLastColumn={isLastColumn} />

      <S.InfoTitle>{item.title}</S.InfoTitle>

      <S.InfoDescription>{item.description}</S.InfoDescription>
    </S.ImageInfos>
  </S.ImageWrapper>
)

export default memo(MasonryCardComponent)
